import { render, staticRenderFns } from "./BiewBadge.vue?vue&type=template&id=2ff208ec&scoped=true&"
import script from "./BiewBadge.vue?vue&type=script&lang=js&"
export * from "./BiewBadge.vue?vue&type=script&lang=js&"
import style0 from "./BiewBadge.vue?vue&type=style&index=0&id=2ff208ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff208ec",
  null
  
)

export default component.exports